<template>
  <ToastModal
    ref="modal"
    :title="$t('SignUp.StepOne.SizeTable')"
    show-mobile-footer
    :width="766"
    modal-id="size-chart-modal"
  >
    <SizeChart />
    <template v-slot:footer>
      <ToastModalFooter class="w-full md:w-auto" variant="plane" color="black" @click="onModalClose" />
    </template>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import ToastModalFooter from '@/components/ToastModal/ToastModalFooter'
import SizeChart from '@/components/SizeChart/SizeChart'

export default {
  name: 'SizeChartModal',
  components: { SizeChart, ToastModal, ToastModalFooter },
  methods: {
    toggleActivation (options) {
      this.$refs.modal.toggleActivation(options)
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
    }
  }
}
</script>
